// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-login {
  max-width: 80vw;
  max-height: 80vh;
  background-color: rgb(233, 231, 222);
  padding: 30px 30px;
  border-radius: 5px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  gap: 30px;
  position: relative;
}
  
.popup-login__heading {
  margin: 0;
}
  
.popup-login__form {
  display: flex;
  flex-direction: column;
}
 
.popup-login__form label {
  display: flex;
  flex-direction: column;
  border: 1px solid rgb(122,148,90);
  border-radius: 5px;
  font-size: 10px;
  padding: 3px 10px 0;
  margin-bottom: 20px;
}

.popup-login__form input {
  padding: 10px 0;
  font-size: 18px;
  line-height: 18px;
  border-style: none;
  background-color: rgb(233, 231, 222);
}

.popup-login__form input:focus {
  outline: none;
}

.popup-login__button {
  padding: 10px;
  margin-bottom: 5px;
  font-size: 18px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
}

.popup-login__button:hover {
  opacity: .8;
}
  
.popup-login__button-green {
  background: rgb(122,148,90);
  color: white;
}

@media screen and (max-width: 540px) {
  .popup-login__heading {
    font-size: 20px;
  }
}

@media screen and (max-width: 520px) {
  .popup-login {
    max-width: 99vw;
    max-height: 99vh;
    padding: 20px;
    gap: 20px;
  }

  .popup-login__form label {
    margin-bottom: 10px;
  }

  .popup-login__heading {
    font-size: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PopupLogin.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".popup-login {\r\n  max-width: 80vw;\r\n  max-height: 80vh;\r\n  background-color: rgb(233, 231, 222);\r\n  padding: 30px 30px;\r\n  border-radius: 5px;\r\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 30px;\r\n  position: relative;\r\n}\r\n  \r\n.popup-login__heading {\r\n  margin: 0;\r\n}\r\n  \r\n.popup-login__form {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n \r\n.popup-login__form label {\r\n  display: flex;\r\n  flex-direction: column;\r\n  border: 1px solid rgb(122,148,90);\r\n  border-radius: 5px;\r\n  font-size: 10px;\r\n  padding: 3px 10px 0;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.popup-login__form input {\r\n  padding: 10px 0;\r\n  font-size: 18px;\r\n  line-height: 18px;\r\n  border-style: none;\r\n  background-color: rgb(233, 231, 222);\r\n}\r\n\r\n.popup-login__form input:focus {\r\n  outline: none;\r\n}\r\n\r\n.popup-login__button {\r\n  padding: 10px;\r\n  margin-bottom: 5px;\r\n  font-size: 18px;\r\n  border: none;\r\n  cursor: pointer;\r\n  border-radius: 5px;\r\n}\r\n\r\n.popup-login__button:hover {\r\n  opacity: .8;\r\n}\r\n  \r\n.popup-login__button-green {\r\n  background: rgb(122,148,90);\r\n  color: white;\r\n}\r\n\r\n@media screen and (max-width: 540px) {\r\n  .popup-login__heading {\r\n    font-size: 20px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 520px) {\r\n  .popup-login {\r\n    max-width: 99vw;\r\n    max-height: 99vh;\r\n    padding: 20px;\r\n    gap: 20px;\r\n  }\r\n\r\n  .popup-login__form label {\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .popup-login__heading {\r\n    font-size: 15px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
